export default __webpack_public_path__ + "static/media/driversinIndia.5bb06c6f.png";